import { render, staticRenderFns } from "./JoinedSignupForm.vue?vue&type=template&id=2ddd3988&scoped=true&"
import script from "./JoinedSignupForm.vue?vue&type=script&lang=js&"
export * from "./JoinedSignupForm.vue?vue&type=script&lang=js&"
import style0 from "./JoinedSignupForm.vue?vue&type=style&index=0&id=2ddd3988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd3988",
  null
  
)

export default component.exports